import GroupsAndReferrersAutocomplete from "./GroupsAndReferrersAutocomplete";

export default GroupsAndReferrersAutocomplete;